import { render } from "./SystemakkreditierungDetailsHochschule.pug?vue&type=template&id=6f1e5a74&lang=pug"
import script from "./SystemakkreditierungDetailsHochschule.js?vue&type=script&lang=js"
export * from "./SystemakkreditierungDetailsHochschule.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__